import React from 'react';

import Placeholder from 'components/consumer/Placeholder';
import classNames from 'classnames';
import PDPNameSectionPlaceholder from '../PDPNameSection/PDPNameSectionPlaceholder';
import PDPShopTabsBarPlaceholder from '../PDPShopTabsBar/PDPShopTabsBarPlaceholder';
import PDPChooseYourOptionsPlaceholder from '../PDPChooseYourOptions/PDPChooseYourOptionsPlaceholder';
import PDPProtectionPlanSelectorPlaceholder from '../PDPProtectionPlanSelector/PDPProtectionPlanSelectorPlaceholder';
import PDPAddToBagSectionPlaceholder from '../PDPAddToBagSection/PDPAddToBagSectionPlaceholder';
import PDPSellingAttributesPlaceholder from '../PDPSellingAttributes/PDPSellingAttributesPlaceholder';
import PDPProductDescriptionPlaceholder from '../PDPProductDescription/PDPProductDescriptionPlaceholder';

const PDPDesktopPlaceholder = ({ className: parentClassName }) => (
  <div
    className={classNames(
      'mx-auto my-0 py-0 flex flex-row-reverse !pt-2 !pb-8 max-[1023px]:hidden px-5 md:px-[3.333vw] min-[1500px]:px-[50px] max-w-[1800px]',
      parentClassName
    )}
  >
    <div className="flex-none min-w-[460px] w-[460px] [@media(width:1024px)]:min-w-[400px] [@media(width:1024px)]:w-[400px]">
      <PDPNameSectionPlaceholder />
      <PDPShopTabsBarPlaceholder />
      <PDPChooseYourOptionsPlaceholder />
      <PDPProtectionPlanSelectorPlaceholder />
      <PDPAddToBagSectionPlaceholder />
      <PDPSellingAttributesPlaceholder />
      <PDPProductDescriptionPlaceholder />
    </div>
    <div className="flex-1 mr-12">
      <div className="max-[1023px]:hidden z-auto m-0 mt-0 pt-2 pl-5 min-h-[45px] static bg-transparent border-0 [&_a]:text-gray-light1 [&_li:last-child_span]:last:text-gray-light1 [&_a:hover]:text-white sm:pt-0 sm:pl-0 md:mt-2">
        <Placeholder loading type="text" style={{ width: '512px' }} />
      </div>
      <div className="sticky top-8">
        <div className="mb-8 flex flex-col items-center relative max-w-[calc((100vh - 194px) / 0.6666666666666666)]">
          <Placeholder
            loading
            type="rect"
            style={{ width: '50vw', height: '70vh', margin: 'none' }}
          />
        </div>
        <div className="flex flex-row justify-center mt-8 p-0 w-full">
          <Placeholder
            loading
            type="rect"
            style={{ width: '450px', height: '60px', margin: 'none' }}
          />
        </div>
      </div>
    </div>
  </div>
);

export default PDPDesktopPlaceholder;
